/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ month: NonNullable<unknown> }} Partner_Billing_Board_Month_Empty_TitleInputs */



/**
* | output |
* | --- |
* | "No billing activity in {month}" |
*
* @param {Partner_Billing_Board_Month_Empty_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_billing_board_month_empty_title = /** @type {((inputs: Partner_Billing_Board_Month_Empty_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Billing_Board_Month_Empty_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Keine Abrechnungsaktivität in ${i?.month}`)
	return /** @type {LocalizedString} */ (`No billing activity in ${i?.month}`)
});